
import request from '@/util/http'


// 获取权责分页
export const homeChargePage=(params)=>request({
    url: '/admin/homeCharge/getChargePage',
    method: 'get',
    params
})


// 获取关联部门列表
export const homeChargeDeptList=(params)=>request({
    url: '/admin/homeCharge/getDeptList',
    method: 'get',
    params
})

// 获取部门树
export const homeChargeDeptTree=()=>request({
    url: '/admin/homeCharge/getDeptTree',
    method: 'get',
})



// 获取服务分类
export const homeChargeServeVoList=()=>request({
    url: '/admin/homeCharge/getServeVoList',
    method: 'get'
})



